import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

const EnterpriseSuccess = () => {
  const { user } = useAuth();
  const emailSentRef = useRef(false);

  useEffect(() => {
    const sendWelcomeEmail = async () => {
      if (!user || emailSentRef.current) return;
      emailSentRef.current = true; // Prevent double-firing in StrictMode
      try {
        const { data, error } = await supabase
          .from("businesses")
          .select("business_email, business_name")
          .eq("user_id", user.id)
          .single();
        
        if (!error && data?.business_email && data?.business_name) {
          await supabase.functions.invoke("onboarding-welcome-email", {
            body: {
              businessEmail: data.business_email,
              businessName: data.business_name,
            }
          });
        }
      } catch (err) {
        console.error("Failed to send welcome email:", err);
      }
    };
    
    sendWelcomeEmail();
  }, [user]);
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-slate-200 shadow-sm text-center pt-6">
        <CardHeader>
          <div className="mx-auto bg-green-100 p-3 rounded-full w-fit mb-4">
            <CheckCircle2 className="w-8 h-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl font-heading font-bold">Thank you for signing up</CardTitle>
          <CardDescription className="text-base mt-2">
            Our agents will contact you soon to discuss your custom Enterprise plan requirements.
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-4 pb-8">
          <Button className="w-full" onClick={() => window.location.href = '/'}>
            Go to dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default EnterpriseSuccess;
